var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-fav"},[_c('div',{staticClass:"container"},[_c('Title',[_vm._v("Mes favoris")])],1),_c('RecipeGrid',{attrs:{"recipes":_vm.recipes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }